export const getChartOptions = () => ({
  cutoutPercentage: 70,
  responsive: true,
  legend: {
    position: 'right',
    labels: {
      padding: 20,
      usePointStyle: true,
    },
  },
  tooltips: {
    displayColors: false,
    titleMarginBottom: 5,
    backgroundColor: '#fff',
    position: 'average',
    titleFontColor: '#666',
    bodyFontColor: '#666',
    borderColor: '#ededed',
    borderWidth: 1,
    callbacks: {
      title: (tooltipItems, { datasets }) => {
        return `${datasets?.[0]?.data?.[tooltipItems?.[0]?.index] || ''}%`;
      },
      label: (tooltipItem) => {
        return DOUGHNUT_LABEL[Object.keys(DOUGHNUT_LABEL)[tooltipItem?.index]] || '';
      },
    },
    titleFontSize: 15,
    xPadding: 15,
    yPadding: 10,
    titleAlign: 'center',
    bodyAlign: 'center',
  },
});

export const DOUGHNUT_COLOR = {
  REGISTRASI_BERHASIL: 'rgba(218, 35, 26, 1)',
  SUDAH_ONBOARDING: 'rgba(20, 111, 180, 1)',
  SUDAH_TRANSAKSI: 'rgba(133, 194, 37, 1)',
};

export const DOUGHNUT_LABEL = {
  REGISTRASI_BERHASIL: 'Registrasi Berhasil',
  SUDAH_ONBOARDING: 'Onboarding',
  SUDAH_TRANSAKSI: 'Transaksi',
};
